export { default } from "./updateCommunicationPreferences";
